import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Customer } from '../model/customer';
import { Project } from '@src/app/models/project';
import { Projectmember } from '../model/projectmember';
import { Projectperson } from '../model/projectperson';
import { Task } from '@src/app/models/task';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProjectuserviewService {

  constructor(private http:HttpClient) { }

  getTasks(projectId:string,pit:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Task[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+projectId+'/task/list/pit/'+pit,httpOptions);
  }
  // get all the projects per person ()
 // /projectperson/list/person/{personId}/organization/{organizationId}
  getPersonProjects(personId:string,orgId:string){
 // getPersonProjects(personId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Projectperson[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/projectperson/list/person/'+personId,httpOptions);
   }
   getCustomers(pit:String){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/list/pit/'+pit,httpOptions)
      .pipe(map((res) => Array.isArray(res) ? res : (res?.Items || [])));
  }


  getCustomerMembers(projectId:string,customerId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    var pit = new Date().toISOString();
    //try cast to Projectmember
    return this.http.get<Projectmember[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customerId.substring(0,36)+'/user/list/pit/'+pit,httpOptions)

  }

}
